export default {
  send: 'Send',
  forward: 'Continue',
  OK: 'Confirm',
  cancel: 'Cancel',
  back: 'Back',
  addToOrder: 'Add to cart',
  updateProduct: 'Update order',
  chooseOptions: 'Order',

  banner: {
    title: 'Closed for orders',
    subtitle: 'Order are open at {openingHour}',
    wait: 'Wait time',
  },

  frontpage: {
    table: 'Order table',
    locations: 'Location',
    menu: 'See menu',
  },

  catering: {
    title: 'Order here',
    amount: 'Number of trays',
    order: 'Finish order',
    deliveryMethod: 'Pick up or send?',
    paymentMethod: 'Select payment method?',
    submit: {
      errors: {
        title: 'Error',
        message: 'Please make sure everything has been filled out',
      },
    },
    content: {
      title: 'Catering service',
      line1: 'Do you have a party coming up?',
      line2: 'Mini-burgers party trays are a fun a delicious alternative to serve at a party. Fifteen cold and adorable burgers per tray.',
      line3: 'Place your order before 1pm the weekday before the day of delivery. Note that orders made for fridays, saturdays, sundays and mondays have to be made before 1pm on the thursday before.',
      ul: {
        li1: '15 burgers per tray',
        li2: 'Price per tray is 5.499 kr.',
        li3: 'Estimated 3-5 burgers per person',
        li4: 'Order in advance',
      },
    },
    form: {
      title: 'Your order',
      login: 'Log in',
      total: 'Total amount of hamburger trays:',
      trays: 'Trays',
      totalItems: 'burgers, food for about {amount} people',
      price: 'Total price:',
      deliveryDate: 'Date of pick up?',
      deliveryTime: 'Time of pick up?',
      deliveryLocation: 'Pick up at',
      deliveryInfo: 'Your information',
      name: 'Name *',
      email: 'Email *',
      phone: 'Phone number *',
      comment: 'Other information you would like to add',
      submit: 'Confirm order',
      errors: {
        name: 'Name cannot be empty',
        phone: 'Phone number cannot be empty',
      },
    },
  },

  date: {
    days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    daysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  },

  user: {
    authenticate: 'Log in',
    phoneNumber: 'Phone number',
    verificationCode: 'Confirmation code',
    fullname: 'Name on the order',
    address: 'Address',
    postalCode: 'Zip code',
    validation: {
      name: 'Name has to be at least 3 letters long',
      address: 'Address missing',
      postalCode: 'Zip code missing',
    },
    addAddress: 'Add an address',
  },

  checkout: {
    hintPhoneNumber: 'Enter a phone number that can receive text message. We will send you a verification code to confirm you are the rightful owner of the phone number.',
    hintVerificationCode: 'We have sent you a verification code. Confirm your phone number by inputting the code.',
    hintFullname: 'Confirm the name for the order.',
    hintAddress: 'Add address for home delivery.',
  },

  payment: {
    locations: 'Choose location',
    methods: 'Payment options',
    header: 'Payment information',
    noDeliveryChosen: 'Choose delivery location',
    cardNumber: 'Card number',
    expiration: 'Expiration',
    expirationMonth: 'Month',
    expirationYear: 'Year',
    ccv: 'CVC number',
    cancel: 'Cancel',
    submitForm: 'Confirm payment information',
    hintPaymentData: 'The order will be paid with the card ****-****-****-{lastFour}',
    phoneNumber: 'Phone number',
    aur: {
      paymentPendingTitle: 'Waiting for payment',
      paymentPendingMessage: 'Complete the payment through the Aur app to finish the order.',
    },
    secure3d: {
      hint: 'Click "Send" to send card information to merchant acquirer.',
      submit: 'Send',
      cancel: 'Cancel',
    },
    valitorPage: {
      hint: 'Click "Send" to pay through Valitor\'s payment site.',
      submit: 'Send',
      cancel: 'Cancel',
      footer: 'It is safe to close the payment site when the transaction is complete or if you want to cancel.',
    },
    validation: {
      cardNumber: {
        required: 'Card number missing',
      },
      ccv: {
        required: 'CVC missing',
      },
      expirationMonth: {
        required: 'Expiration month missing',
      },
      expirationYear: {
        required: 'Expiration year missing',
      },
      phoneNumber: {
        required: 'Phone number missing',
        tooShort: 'Phone number too short',
      },
    },
    errorFromPaymentService: 'merchant acquirer could not process payment.',
  },

  deliveryMethods: {
    deliveryMethods: 'Delivery',
    deliveredAt: 'Your order will be delivered at',
  },

  email: {
    contact: {
      title: 'Contact',
      name: 'Name *',
      email: 'Email *',
      message: 'Message *',
      successDialog: {
        title: 'Message sent',
        message: 'Thank you for the message. We will contact you if needed.',
      },
    },
    application: {
      successDialog: {
        title: 'Message sent',
        message: 'Thank you for the application. We will contact you.',
      },
    },
    errors: {
      name: 'Name cannot be empty',
      email: 'Email cannot be empty',
      message: 'Message cannot be empty',
      emailInvalid: 'Incorrect format for email',
    },
    buttons: {
      clear: 'Clear',
      submit: 'Send',
    },
    successDialog: {
      title: 'Message sent',
      message: '',
    },
  },

  product: {
    split: 'Split in half',
    firstHalf: 'Former half',
    secondHalf: 'Latter half',
  },

  order: {
    footer: 'Your order',
    header: 'Your order',
    thankYou: 'Thank you for the order!',
    thankYouCateringDetails: 'Your order will be served and delivered at {delivered} from our location at {location}',
    thankYouDetails: 'Your order has been received and will be ready in about {wait} min. Please contact us at the counter when you have arrived. Enjoy!',
    thankYouDetailsOnSite: 'Your order has been received and will be ready in about {wait} min. grab yourself a glass and cutlery, find yourself an available seat. We will call your name when your order is ready. Enjoy!',
    thankYouDetailsQR: 'Your order will be ready soon. Please re-enter the code if you\'d like to order more. Enjoy!.',
    isEmpty: 'Your order is currently empty. Take a look at our menu and add to your order',
    total: 'Total amount',
    checkout: 'Finish order',
    confirm: 'Confirm order',
    productAdded: '{product} has been added to your order',
    productUpdated: '{product} updated',
    removeFromOrder: 'Remove',
    editProduct: 'Change',
    viewMenu: 'Back to menu',
    order: 'Order',
    coupon: 'Coupon',
    removeProduct: {
      title: 'Remove from order',
      message: '{product} has been removed from your order',
    },
    sendOrder: {
      title: 'Confirm order',
      message: 'Your order will be saved and served after selecting confirm.',
    },
  },

  location: {
    openingHours: 'Open today',
    openingDays: {
      weekdays: 'Mondays - Fridays',
      weekdaysShort: 'Mon - Fri',
      weekends: 'Saturdays and Sundays',
      weekendsShort: 'Sat and Sun',
      everyDay: 'Open every day',
    },
    waitingTimes: {
      minutes: 'minutes',
      min: 'min',
    },
    closed: 'We are closed for orders at the moment. Please try again during opening hours.',
  },

  footer: {
    openingHours: 'Open every day',
    open: 'Open',
    copyright: 'All right reserved',
    about: 'About',
    jobApplication: 'Job application',
  },

  header: {
    openingHours: 'Opening hours',
    about: 'About Fabrikkan',
  },

  form: {
    months: {
      jan: 'January',
      feb: 'February',
      mar: 'March',
      apr: 'April',
      mai: 'May',
      jun: 'June',
      jul: 'July',
      aug: 'August',
      sep: 'September',
      oct: 'October',
      nov: 'November',
      dec: 'December',
    },
  },

  errors: {
    default: {
      title: 'Error has ocurred',
      message: 'Action returned the error: {error}',
    },
    email: {
      title: 'Error',
      message: 'Sending message failed. Try again later or send us an email at fabrikkan@fabrikkan.is',
    },
    code: {
      500: {
        title: 'Error from server',
        message: 'Server could not perform the action: "{error}"',
      },
      pilotErrorCouldNotCreateOrder: {
        title: 'Could not save order',
        message: '{error}',
      },
      pilotErrorOrderNotSaved: {
        title: 'Could not save order',
        message: '{error}',
      },
      pilotErrorPaymentGatewayError: {
        title: 'Error when contacting payment service',
        message: 'Message from payment service: {error}',
      },
      pilotErrorNoData: {
        title: 'Missing data',
        message: 'Order was not saved. Invalid format for data: {error}',
      },
      pilotErrorPaymentProcessError: {
        title: 'Error when contacting payment service',
        message: 'Message from payment service: {error}',
      },
      pilotErrorInvalidVerificationCode: {
        title: 'Invalid confirmation code',
        message: 'Please check if code was entered correctly.',
      },
      pilotErrorCouponExpired: {
        title: 'Expired coupon',
        message: 'Code inactive.',
      },
      pilotErrorCouponNotFound: {
        title: 'Coupon not found',
        message: 'Please check if coupon code was entered correctly',
      },
      pilotErrorInvalidCardNumber: {
        title: 'Invalid card number',
        message: 'Please check if card number was entered correctly.',
      },
      pilotErrorExpiredCard: {
        title: 'Card has expired',
        message: 'Please try another card or payment option.',
      },
      pilotErrorInvalidCardLength: {
        title: 'Invalid card number',
        message: 'Card number length has to be 11 to 19 digits long',
      },
      pilotErrorOrderNotValid: {
        title: 'Order not found',
        message: 'This can occur due to change in inventory.',
      },
      pilotErrorItemNotAllowedForDeliveryMethod: {
        title: 'We cannot process the order"',
        message: 'Please select another delivery method.',
      },
      pilotErrorDeliveryMethodMinTotalPrice: {
        title: 'Minimum amount no reached',
        message: 'Please add more items to order to select this delivery method.',
      },
      pilotErrorCouponWrongDeliveryMethod: {
        title: 'Invalid coupon',
        message: 'This coupon cannot be used for this delivery method.',
      },
      pilotErrorInvalidPinNumber: {
        title: 'Invalid pin number',
        message: 'Try again.',
      },
      couponNeedsDesktop: {
        title: 'Invalid coupon',
        message: 'This coupon can only be used on our website.',
      },
      couponNeedsCordova: {
        title: 'Invalid coupon',
        message: 'This coupon can only be used in our app.',
      },
      notAllowed: {
        title: 'Operation not performed',
        message: 'Unauthorized user.',
      },
      ECONNABORTED: {
        title: 'Timed out',
        message: 'Process took longer than expected.',
      },
    },
    networkError: {
      title: 'Connection error',
      message: 'Connection to the service could not be established. Please check if your device is connected to the internet.',
    },
  },
};
